














import { FarmCentroid, FarmListFilter } from '@/api/farms/types';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import FarmsMap from './FarmsMap.vue';
import { LocationPayload } from './types';
import * as farmsService from "@/services/farms";
import MapSidebarOverlayController from "../map-sidebar-overlay/MapSidebarOverlayController.vue";
import { FarmMapSummary } from "@/api/farms/types";

const STORAGE_KEY = '_farms-home-location'

@Component({
   name: 'FarmsMapController',
   components: {
     FarmsMap,
     MapSidebarOverlay: MapSidebarOverlayController,
   }
})
export default class FarmsMapController extends Vue {
  @Prop({type: Object})
  private farmFilter!: FarmListFilter | null;

  private startLocation: LocationPayload | null = null;
  private centroids: FarmCentroid[] = [];
  private isMapSideBarVisible: boolean = false;
  private mapSummaryInfo: FarmMapSummary | null = null;
  private uuid: string | null = null
  private searchTimer: any;

  private created() {
    const loadedLocation = localStorage.getItem(STORAGE_KEY);
    this.startLocation = loadedLocation ? JSON.parse(loadedLocation) : loadedLocation;
  }

  private persistLocation(payload: LocationPayload) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    } catch {}
  }

  @Watch('farmFilter', { deep: true, immediate: true })
  private async getFarmsCentroids(filter: FarmListFilter) {
    if (!!filter) {
      this.searchTimeout(filter);
    }
  }


  private searchTimeout(filter: FarmListFilter) {
    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
      this.searchTimer = null;
    }8
    this.searchTimer = setTimeout(async () => {
        this.centroids = await farmsService.getFarmsCentroids(filter)

        if (filter.lngLat) {
          try {
            const lng = parseFloat(filter.lngLat.split(',')[0].trim());
            const lat = parseFloat(filter.lngLat.split(',')[1].trim());
            const payload = { zoom: 12, lat, lng} as LocationPayload;
            this.startLocation = payload;
            this.persistLocation(payload);
          } catch (error) {
            console.log(error);
          }
        }

      }
      , 1000);
  }

  private getUuid(uuid: string){
    this.uuid = uuid;
    this.openMapOverlaySidebar();
  }

  private openMapOverlaySidebar() {
    this.isMapSideBarVisible = true;
  }

  private closeMapOverlaySidebar() {
    this.isMapSideBarVisible = false;
  }
}
